import Hero from "../components/site/Hero";
import TrustBar from "../components/site/TrustBar";
import BookingBand from "../components/site/BookingBand";
import Property from "../components/site/Property";
import PropertyLandhaus from "../components/site/PropertyLandhaus";
import Units from "../components/site/Units";
import Gallery from "../components/site/Gallery";
import Rooms from "../components/site/Rooms";
import Amenities from "../components/site/Amenities";
import Location from "../components/site/Location";
import Nature from "../components/site/Nature";
import Reviews from "../components/site/Reviews";
import FAQ from "../components/site/FAQ";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

export default function HomePage() {
  const { t } = useLang();
  return (
    <main data-testid="home-page">
      <Hero />
      <TrustBar />
      <BookingBand />
      <Property />
      <PropertyLandhaus />
      <Units />
      <Gallery />
      <Rooms />
      <Amenities />
      <Location />
      <Nature />
      <Reviews />
      <FAQ />

      {/* Final CTA */}
      <section data-testid="final-cta" className="bg-[hsl(var(--cream))] text-[hsl(var(--cream-foreground))] section-pad">
        <div className="container-x text-center max-w-3xl mx-auto">
          <div className="overline mb-5">{t.hero.eyebrow}</div>
          <h2 className="font-serif font-light text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight text-[hsl(var(--foreground))]">
            {t.reviews.title}
          </h2>
          <Link to="/book" data-testid="final-cta-book" className="btn-primary mt-10 inline-flex">
            {t.nav.book} <span aria-hidden>→</span>
          </Link>
        </div>
      </section>
    </main>
  );
}
